import stage from '../components/stage'
import renderer from '../components/render'
import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'



class Shelf extends Component {

    constructor(element) {


        super(element);
        this.element = element
        this.el = $(element)

        this.ref = {
            item: [],
            product: [],
            row: []
        }

    }

    mount() {
        
        _each(this.ref.item , (item)=>{
            
            $(item).on('click', (e)=>{
                e.preventDefault()
                const menu  = item.dataset.menu;
                $('.product--active').removeClass('product--active')
                $('.product-list__item--active').removeClass('product-list__item--active')
                item.classList.add('product-list__item--active')

                $(`[data-product="${menu}"]`).addClass('product--active')

                console.log($(item).parents('.shelfrow').attr('id'));

                gsap.to(window, {
                    ease: 'none',
                    duration: 0,
                    scrollTo: `#${$(item).parents('.shelfrow').attr('id')}`
                });
            })
       
        })


    }



    unmount() {
       
    }


}

module.exports = Shelf
